@if (showModeToggle()) {
    <div class="filter-bar" [class.scrolled]="scrolled()">
        <div class="filter-mode-toggle" [class.disabled]="isFavoriteListFilterMode()">
            <button
                type="button"
                class="mode-button user"
                [class.active]="isUserFilterMode()"
                [class.dirty]="isUserFilterDirty()"
                [disabled]="isFavoriteListFilterMode()"
                (click)="onSetFilterMode(FilterMode.User)"
            >
                <span class="label">Mitt filter</span>
                @if (isUserFilterDirty()) {
                    <span class="icon save" title="Lagre mitt filter" (click)="onSaveUserFilter(); $event.stopPropagation()"></span>
                    <span class="icon undo" title="Angre filterendringer" (click)="onUndoUserFilter(); $event.stopPropagation()"></span>
                }
            </button>
            <button
                type="button"
                class="mode-button standard"
                [class.active]="isStandardFilterMode()"
                [class.dirty]="isStandardFilterDirty()"
                [disabled]="isFavoriteListFilterMode()"
                (click)="onSetFilterMode(FilterMode.Standard)"
            >
                <span class="label">Basis filter</span>
            </button>
        </div>
    </div>
}
